import { EventEmitter } from 'modules/event-emitter';

export interface SignedDocumentsEvents {
  'refresh-grid': { prescriptionID: string };
}

export const signedDocumentEmitter = new EventEmitter<SignedDocumentsEvents>();
